export enum ViewEvidence {
    EDIT,
    DETAIL
}